type ImgProps = React.ComponentProps<"img"> & { alt: string };

/**
 * An image from /public. Served as is: there's no image optimization on this site.
 */
export default function LocalImage({ alt, ...rest }: ImgProps) {
    // eslint-disable-next-line @next/next/no-img-element
    return <img alt={alt} loading="lazy" decoding="async" style={{ color: "transparent" }} {...rest} />
}